import Reveal from "@/components/Reveal";

const POINTS = [
  {
    k: "Not just listening",
    title: "Patient voice is translated into evidence-ready outputs, not left as disconnected themes.",
  },
  {
    k: "Not just dashboards",
    title: "Teams receive strategic interpretation and actionable recommendations, not analytics alone.",
  },
  {
    k: "Not just AI",
    title: "AI accelerates synthesis. Expert validation ensures relevance, credibility, and decision readiness.",
  },
];

export default function DifferentiatorSection() {
  return (
    <section className="bg-ink-2 relative border-t border-white/[0.06]" data-testid="differentiator-section">
      <div className="container-edge py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-8">
          <Reveal className="col-span-12 lg:col-span-5">
            <div className="eyebrow">Why Voice2Evidence</div>
            <h2 className="font-serif font-light text-3xl md:text-5xl lg:text-[3.5rem] tracking-tight mt-4 text-parchment-bright leading-[1.05]">
              Not just listening. Not just dashboards. Not just AI.
            </h2>
          </Reveal>

          <div className="col-span-12 lg:col-span-7 grid grid-cols-1 gap-px bg-white/[0.08] border border-white/[0.08]">
            {POINTS.map((p, i) => (
              <Reveal
                key={p.k}
                delay={i * 90}
                className="bg-ink-1 p-8 lg:p-10 card-dark-hover"
                data-testid={`diff-${p.k.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
              >
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-rust mb-3">{p.k}</div>
                <h3 className="font-serif text-2xl md:text-[1.7rem] text-parchment-bright leading-snug">{p.title}</h3>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
